import React from "react";
import PropTypes from "prop-types";
import { MEDIA_STATUS_LABELS } from "../constants";
import { NeoTable, NeoBadge, NeoButton } from "../../../components/Common";

/**
 * MediaList
 * Lista de mídias no painel de Gestão do Totem utilizando o NeoTable do Neo Design System.
 */
const MediaList = ({ medias = [], onSelect, loading = false }) => {

    const formatDateBR = (dateString) => {
        if (!dateString) return "";
        const parts = dateString.split("-");
        if (parts.length === 3) return `${parts[2]}/${parts[1]}/${parts[0]}`;
        return dateString;
    };

    const columns = [
        {
            label: "Foto",
            key: "imageUrl",
            width: "80px",
            render: (row) => (
                <div
                    className="overflow-hidden bg-light d-flex align-items-center justify-content-center"
                    style={{ 
                        width: 40, 
                        height: 71, 
                        aspectRatio: "9/16",
                        borderRadius: "8px",
                        border: "1.5px solid rgba(72, 39, 18, 0.12)"
                    }}
                >
                    {row.type === "carousel" && row.carouselImages?.length > 0 ? (
                        <img
                            src={row.carouselImages[0]?.url}
                            alt={row.name}
                            className="w-100 h-100"
                            style={{ objectFit: "cover" }}
                        />
                    ) : row.imageUrl ? (
                        <img
                            src={row.imageUrl}
                            alt={row.name}
                            className="w-100 h-100"
                            style={{ objectFit: "cover" }}
                        />
                    ) : (
                        <i className="mdi mdi-image-outline text-muted font-size-16" />
                    )}
                </div>
            )
        },
        {
            label: "Nome da Campanha",
            key: "name",
            render: (row) => (
                <div className="py-1">
                    <h5 className="mb-0 fw-bold font-size-14 text-dark neo-font-outfit">
                        {row.name}
                    </h5>
                    {row.type === "carousel" && (
                        <span className="text-muted font-size-11 d-block mt-0.5" style={{ fontFamily: "Outfit" }}>
                            <i className="mdi mdi-view-carousel-outline text-accent me-1" />
                            Carrossel • {row.carouselImages?.length || 0} imagens • {row.slideDuration || 8}s
                        </span>
                    )}
                </div>
            )
        },
        {
            label: "Status",
            key: "status",
            width: "120px",
            render: (row) => {
                const statusConfig = MEDIA_STATUS_LABELS[row.status] || MEDIA_STATUS_LABELS.inactive;
                const isActive = row.status === "active";
                return (
                    <NeoBadge color={isActive ? "success" : "muted"}>
                        {statusConfig.label}
                    </NeoBadge>
                );
            }
        },
        {
            label: "Data de Início",
            key: "startDate",
            width: "140px",
            render: (row) => (
                <span className="fw-semibold text-muted font-size-13" style={{ fontFamily: "Outfit" }}>
                    {formatDateBR(row.startDate)}
                </span>
            )
        },
        {
            label: "Data de Fim",
            key: "endDate",
            width: "140px",
            render: (row) => (
                <span className="fw-semibold text-muted font-size-13" style={{ fontFamily: "Outfit" }}>
                    {formatDateBR(row.endDate)}
                </span>
            )
        },
        {
            label: "Ações",
            key: "actions",
            align: "right",
            width: "90px",
            render: (row) => (
                <NeoButton
                    variant="outline-primary"
                    size="sm"
                    square
                    icon="mdi-pencil-outline"
                    title="Editar"
                    onClick={(e) => {
                        e.stopPropagation();
                        onSelect(row);
                    }}
                />
            )
        }
    ];

    return (
        <div style={{ minHeight: "300px" }}>
            <NeoTable
                data={medias}
                columns={columns}
                keyField="id"
                loading={loading}
                emptyMessage="Nenhuma mídia encontrada"
                emptySubMessage="Crie uma nova mídia para exibir no Totem."
                onRowClick={(row) => onSelect(row)}
            />
        </div>
    );
};

MediaList.propTypes = {
    medias: PropTypes.array,
    onSelect: PropTypes.func.isRequired,
    loading: PropTypes.bool
};

export default MediaList;
